import React from 'react';
import Alertify from 'alertifyjs';
import Core from './funciones_extras.js';
import '../css/gestion-pacientes.css';
import '../css/especialidades.css';

function inicialesEspecialidad(nombre) {
    const n = (nombre || '').trim();
    if (!n) return '?';
    const partes = n.split(/\s+/);
    if (partes.length >= 2) return (partes[0][0] + partes[1][0]).toUpperCase();
    return n.slice(0, 2).toUpperCase();
}

function formatearFecha(fecha) {
    if (!fecha) return '—';
    try {
        return new Date(fecha).toLocaleDateString('es-DO', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    } catch (e) {
        return '—';
    }
}

class Especialidades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            especialidades: [],
            stats: { activas: 0, inactivas: 0, total: 0 },
            mostrarFormulario: false,
            especialidadActual: null,
            modoEdicion: false,
            filtroEstado: 'activas',
            cargando: false,
            guardando: false,
            buscador: '',
        };
    }

    componentDidMount() {
        this.cargarStats();
        this.cargarEspecialidades();
    }

    cargarStats = () => {
        Core.listar_todas_especialidades()
            .then((data) => {
                const lista = Array.isArray(data) ? data : [];
                this.setState({
                    stats: {
                        activas: lista.filter((esp) => esp.estado).length,
                        inactivas: lista.filter((esp) => !esp.estado).length,
                        total: lista.length,
                    },
                });
            })
            .catch(() => {});
    };

    cargarEspecialidades = () => {
        const { filtroEstado } = this.state;
        this.setState({ cargando: true });

        const finalizar = (data) => {
            this.setState({ especialidades: Array.isArray(data) ? data : [], cargando: false });
        };

        if (filtroEstado === 'todas') {
            Core.listar_todas_especialidades().then(finalizar).catch(this.onErrorCarga);
        } else if (filtroEstado === 'inactivas') {
            Core.listar_todas_especialidades()
                .then((data) => finalizar((data || []).filter((esp) => !esp.estado)))
                .catch(this.onErrorCarga);
        } else {
            Core.listar_especialidades().then(finalizar).catch(this.onErrorCarga);
        }
    };

    onErrorCarga = () => {
        this.setState({ cargando: false });
    };

    abrirFormulario = (especialidad = null) => {
        this.setState({
            especialidadActual: especialidad
                ? { ...especialidad }
                : { nombre: '', descripcion: '', estado: true },
            mostrarFormulario: true,
            modoEdicion: especialidad !== null,
        });
    };

    cerrarFormulario = () => {
        this.setState({
            mostrarFormulario: false,
            especialidadActual: null,
            modoEdicion: false,
            guardando: false,
        });
    };

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState((prev) => ({
            especialidadActual: {
                ...prev.especialidadActual,
                [name]: type === 'checkbox' ? checked : value,
            },
        }));
    };

    handleBuscar = (e) => {
        this.setState({ buscador: e.target.value });
    };

    guardarEspecialidad = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const { especialidadActual, modoEdicion } = this.state;

        if (!especialidadActual.nombre || !especialidadActual.nombre.trim()) {
            Alertify.error('El nombre de la especialidad es requerido');
            return;
        }

        const datos = {
            nombre: especialidadActual.nombre.trim(),
            descripcion: (especialidadActual.descripcion || '').trim(),
            estado: especialidadActual.estado !== undefined ? especialidadActual.estado : true,
        };

        this.setState({ guardando: true });
        const peticion = modoEdicion
            ? Core.actualizar_especialidad(especialidadActual.id, datos)
            : Core.crear_especialidad(datos);

        peticion
            .then((response) => {
                Alertify.success(
                    response.message ||
                        (modoEdicion ? 'Especialidad actualizada' : 'Especialidad creada')
                );
                this.cerrarFormulario();
                this.cargarStats();
                this.cargarEspecialidades();
            })
            .catch(() => {
                this.setState({ guardando: false });
            });
    };

    eliminarEspecialidad = (id) => {
        Alertify.confirm(
            'Desactivar especialidad',
            'Si hay doctores usando esta especialidad, solo se desactivará.',
            () => {
                Core.eliminar_especialidad(id).then((response) => {
                    Alertify.success(response.message || 'Especialidad desactivada');
                    this.cargarStats();
                    this.cargarEspecialidades();
                });
            },
            () => Alertify.message('Cancelado')
        );
    };

    activarEspecialidad = (id) => {
        Core.activar_especialidad(id).then((response) => {
            Alertify.success(response.message || 'Especialidad activada');
            this.cargarStats();
            this.cargarEspecialidades();
        });
    };

    cambiarFiltro = (filtro) => {
        this.setState({ filtroEstado: filtro, buscador: '' }, this.cargarEspecialidades);
    };

    getEspecialidadesFiltradas = () => {
        const { especialidades, buscador } = this.state;
        if (!buscador.trim()) return especialidades;
        const q = buscador.toLowerCase().trim();
        return especialidades.filter(
            (esp) =>
                (esp.nombre && esp.nombre.toLowerCase().includes(q)) ||
                (esp.descripcion && esp.descripcion.toLowerCase().includes(q))
        );
    };

    renderModal = () => {
        const { mostrarFormulario, especialidadActual, modoEdicion, guardando } = this.state;
        if (!mostrarFormulario || !especialidadActual) return null;

        return (
            <div
                className="especialidades-modal-backdrop"
                onClick={(e) => e.target === e.currentTarget && this.cerrarFormulario()}
                role="presentation"
            >
                <div className="especialidades-modal" role="dialog" aria-modal="true">
                    <div className="especialidades-modal-header">
                        <div>
                            <h2 className="especialidades-modal-title">
                                {modoEdicion ? 'Editar especialidad' : 'Nueva especialidad'}
                            </h2>
                            <p className="especialidades-modal-sub">
                                {modoEdicion
                                    ? 'Modifique nombre, descripción o estado'
                                    : 'Registre una especialidad para asignar a doctores'}
                            </p>
                        </div>
                        <button
                            type="button"
                            className="especialidades-modal-close"
                            onClick={this.cerrarFormulario}
                            aria-label="Cerrar"
                        >
                            <i className="fas fa-times" />
                        </button>
                    </div>
                    <form onSubmit={this.guardarEspecialidad}>
                        <div className="especialidades-modal-body">
                            <div className="agregar-paciente-field">
                                <label htmlFor="esp-nombre" className="agregar-paciente-label">
                                    Nombre *
                                </label>
                                <input
                                    type="text"
                                    id="esp-nombre"
                                    name="nombre"
                                    className="agregar-paciente-input form-control"
                                    value={especialidadActual.nombre || ''}
                                    onChange={this.handleInputChange}
                                    placeholder="Ej. Ortodoncia, Endodoncia…"
                                    required
                                    autoFocus
                                />
                            </div>
                            <div className="agregar-paciente-field">
                                <label htmlFor="esp-desc" className="agregar-paciente-label">
                                    Descripción
                                    <span className="agregar-paciente-label-optional"> (opcional)</span>
                                </label>
                                <textarea
                                    id="esp-desc"
                                    name="descripcion"
                                    className="agregar-paciente-input form-control"
                                    rows={3}
                                    value={especialidadActual.descripcion || ''}
                                    onChange={this.handleInputChange}
                                    placeholder="Breve descripción de la especialidad"
                                    style={{ minHeight: 88, resize: 'vertical' }}
                                />
                            </div>
                            {modoEdicion && (
                                <div className="especialidades-toggle-box">
                                    <div className="agregar-paciente-pediatrico-header" style={{ marginBottom: 0 }}>
                                        <span className="agregar-paciente-label" style={{ marginBottom: 0 }}>
                                            <i className="fas fa-power-off" style={{ color: '#667eea', marginRight: 8 }} />
                                            Especialidad activa
                                        </span>
                                        <label className="agregar-paciente-toggle">
                                            <input
                                                type="checkbox"
                                                name="estado"
                                                checked={!!especialidadActual.estado}
                                                onChange={this.handleInputChange}
                                            />
                                            <span className="agregar-paciente-toggle-track" />
                                            <span className="agregar-paciente-toggle-thumb" />
                                        </label>
                                    </div>
                                    <p className="form-text text-muted mb-0 mt-2" style={{ fontSize: 12 }}>
                                        Las inactivas no aparecen al registrar doctores.
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="agregar-paciente-actions" style={{ padding: '0 22px 22px', marginTop: 0, borderTop: 'none' }}>
                            <button
                                type="button"
                                className="agregar-paciente-btn agregar-paciente-btn--ghost"
                                onClick={this.cerrarFormulario}
                                disabled={guardando}
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="agregar-paciente-btn agregar-paciente-btn--primary"
                                disabled={guardando}
                            >
                                {guardando ? (
                                    <><i className="fas fa-spinner fa-spin" /> Guardando…</>
                                ) : (
                                    <><i className={`fas ${modoEdicion ? 'fa-save' : 'fa-plus'}`} /> {modoEdicion ? 'Guardar cambios' : 'Crear especialidad'}</>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };

    render() {
        const { filtroEstado, cargando, buscador, stats } = this.state;
        const lista = this.getEspecialidadesFiltradas();

        return (
            <div className="col-12 col-md-10 listado-pacientes-page especialidades-page kadosh-form-page">
                <div className="listado-pacientes-hero">
                    <div className="listado-pacientes-hero-info">
                        <div className="listado-pacientes-hero-icon">
                            <i className="fas fa-stethoscope" />
                        </div>
                        <div>
                            <h1 className="listado-pacientes-hero-title">Especialidades</h1>
                            <p className="listado-pacientes-hero-subtitle">
                                Catálogo de especialidades médicas para doctores
                            </p>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="kadosh-btn kadosh-btn--primary"
                        onClick={() => this.abrirFormulario()}
                        style={{ alignSelf: 'center', flexShrink: 0 }}
                    >
                        <i className="fas fa-plus" />
                        Nueva especialidad
                    </button>
                </div>

                <div className="especialidades-stats">
                    <div className="especialidades-stat">
                        <div className="especialidades-stat-icon especialidades-stat-icon--activas">
                            <i className="fas fa-check" />
                        </div>
                        <div>
                            <p className="especialidades-stat-label">Activas</p>
                            <p className="especialidades-stat-num">{stats.activas}</p>
                        </div>
                    </div>
                    <div className="especialidades-stat">
                        <div className="especialidades-stat-icon especialidades-stat-icon--inactivas">
                            <i className="fas fa-ban" />
                        </div>
                        <div>
                            <p className="especialidades-stat-label">Inactivas</p>
                            <p className="especialidades-stat-num">{stats.inactivas}</p>
                        </div>
                    </div>
                    <div className="especialidades-stat">
                        <div className="especialidades-stat-icon especialidades-stat-icon--total">
                            <i className="fas fa-layer-group" />
                        </div>
                        <div>
                            <p className="especialidades-stat-label">Total</p>
                            <p className="especialidades-stat-num">{stats.total}</p>
                        </div>
                    </div>
                </div>

                <div className="especialidades-toolbar">
                    <div className="especialidades-filtros" role="group" aria-label="Filtrar por estado">
                        {[
                            { key: 'activas', label: 'Activas', icon: 'fa-check-circle' },
                            { key: 'inactivas', label: 'Inactivas', icon: 'fa-ban' },
                            { key: 'todas', label: 'Todas', icon: 'fa-list' },
                        ].map((f) => (
                            <button
                                key={f.key}
                                type="button"
                                className={`especialidades-filtro-btn${filtroEstado === f.key ? ' is-active' : ''}`}
                                onClick={() => this.cambiarFiltro(f.key)}
                            >
                                <i className={`fas ${f.icon}`} />
                                {f.label}
                            </button>
                        ))}
                    </div>
                    <div className="especialidades-search">
                        <i className="fas fa-search" />
                        <input
                            type="search"
                            placeholder="Buscar por nombre o descripción…"
                            value={buscador}
                            onChange={this.handleBuscar}
                            aria-label="Buscar especialidades"
                        />
                    </div>
                </div>

                <div className="listado-pacientes-table-card">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0 listado-pacientes-table">
                            <thead>
                                <tr>
                                    <th style={{ width: 52 }} />
                                    <th>Nombre</th>
                                    <th>Descripción</th>
                                    <th style={{ textAlign: 'center' }}>Estado</th>
                                    <th>Fecha</th>
                                    <th style={{ textAlign: 'center', width: 120 }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cargando && (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <i className="fas fa-spinner fa-spin fa-lg" style={{ color: '#667eea' }} />
                                            <p className="text-muted mb-0 mt-2">Cargando especialidades…</p>
                                        </td>
                                    </tr>
                                )}
                                {!cargando && lista.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className="listado-pacientes-empty">
                                            <i className="fas fa-stethoscope" />
                                            {buscador
                                                ? 'No hay resultados para su búsqueda'
                                                : 'No hay especialidades en este filtro'}
                                            {!buscador && filtroEstado === 'activas' && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="kadosh-btn kadosh-btn--primary"
                                                        onClick={() => this.abrirFormulario()}
                                                    >
                                                        <i className="fas fa-plus" />
                                                        Agregar primera especialidad
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                                {!cargando &&
                                    lista.map((esp) => (
                                        <tr key={esp.id}>
                                            <td>
                                                <span
                                                    className="listado-pacientes-avatar"
                                                    style={
                                                        !esp.estado
                                                            ? { background: '#94a3b8', boxShadow: 'none' }
                                                            : undefined
                                                    }
                                                >
                                                    {inicialesEspecialidad(esp.nombre)}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="listado-pacientes-nombre-cell">{esp.nombre}</div>
                                            </td>
                                            <td>
                                                {esp.descripcion ? (
                                                    <span className="especialidades-desc" title={esp.descripcion}>
                                                        {esp.descripcion.length > 72
                                                            ? `${esp.descripcion.slice(0, 72)}…`
                                                            : esp.descripcion}
                                                    </span>
                                                ) : (
                                                    <span className="especialidades-desc especialidades-desc--empty">
                                                        Sin descripción
                                                    </span>
                                                )}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <span
                                                    className={`especialidades-badge ${
                                                        esp.estado
                                                            ? 'especialidades-badge--activa'
                                                            : 'especialidades-badge--inactiva'
                                                    }`}
                                                >
                                                    <i className={`fas ${esp.estado ? 'fa-check' : 'fa-ban'}`} />
                                                    {esp.estado ? 'Activa' : 'Inactiva'}
                                                </span>
                                            </td>
                                            <td style={{ color: '#94a3b8', fontSize: 13 }}>
                                                {formatearFecha(esp.created_at)}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className="especialidades-acciones">
                                                    <button
                                                        type="button"
                                                        title="Editar"
                                                        className="listado-pacientes-accion listado-pacientes-accion--editar"
                                                        onClick={() => this.abrirFormulario(esp)}
                                                    >
                                                        <i className="fas fa-pen" />
                                                    </button>
                                                    {esp.estado ? (
                                                        <button
                                                            type="button"
                                                            title="Desactivar"
                                                            className="listado-pacientes-accion"
                                                            style={{ background: '#fef2f2', color: '#dc2626' }}
                                                            onClick={() => this.eliminarEspecialidad(esp.id)}
                                                        >
                                                            <i className="fas fa-ban" />
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            title="Activar"
                                                            className="listado-pacientes-accion"
                                                            style={{ background: '#ecfdf5', color: '#059669' }}
                                                            onClick={() => this.activarEspecialidad(esp.id)}
                                                        >
                                                            <i className="fas fa-check" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {this.renderModal()}
            </div>
        );
    }
}

export default Especialidades;
